const AMPLITUDE_KEY = /amplitude|^AMP_|^amp_/i;

function clearMatchingKeys(storage) {
  if (!storage) return;

  const keys = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key && AMPLITUDE_KEY.test(key)) keys.push(key);
  }

  keys.forEach((key) => storage.removeItem(key));
}

function clearAmplitudeCookies() {
  if (typeof document === "undefined" || !document.cookie) return;

  const host = window.location.hostname;
  const domains = new Set(["", host, `.${host}`]);
  const parts = host.split(".");
  if (parts.length > 2) {
    domains.add(`.${parts.slice(-2).join(".")}`);
  }

  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim();
    if (!name || !AMPLITUDE_KEY.test(name)) return;

    domains.forEach((domain) => {
      const domainAttr = domain ? `; domain=${domain}` : "";
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainAttr}`;
    });
  });
}

export function clearAmplitudeStorage() {
  if (typeof window === "undefined") return;

  try {
    clearMatchingKeys(window.localStorage);
    clearMatchingKeys(window.sessionStorage);
    clearAmplitudeCookies();
  } catch (err) {
    console.error("Failed to clear Amplitude storage", err);
  }
}
